import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_NAME = "ACRE — Al Casa Real Estate";
const ORIGIN = "https://alcasa.co.uk";
const DEFAULT_TITLE = "Dubai Property Investment for UK Buyers | ACRE";

const SEO = ({ title, description, path = "/", type = "website", jsonLd, breadcrumbs }) => {
  const fullTitle = !title ? DEFAULT_TITLE : title.endsWith("| ACRE") ? title : `${title} | ${SITE_NAME}`;
  const canonical = `${ORIGIN}${path}`;
  const ldBlocks = [];
  if (jsonLd) ldBlocks.push(jsonLd);
  if (breadcrumbs) {
    ldBlocks.push({
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: breadcrumbs.map((b, i) => ({
        "@type": "ListItem",
        position: i + 1,
        name: b.name,
        item: `${ORIGIN}${b.path}`,
      })),
    });
  }
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {ldBlocks.map((d, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(d)}</script>
      ))}
    </Helmet>
  );
};

export default SEO;
export { ORIGIN };
